/* Il comportamento del registro di bordo (snippets/bh-registro.liquid). Poco JS, nessuna libreria.
   1. la fascia apre e chiude il registro (aria-expanded), solo quando la tocchi: niente si apre o si riscrive da solo, il fuoco resta dov'è;
   2. il nastro rosso si stacca e si rimette (aria-expanded), sotto c'è la cosa buttata;
   3. sui capi col Lato B mette nel registro le parole del riquadro «Lato agenti», che la sezione na-lato-b scrive tradotte in
      <template id="bh-rg-latob">; una riga senza parole si toglie;
   4. il numero delle buttate prende il rosso dove regge almeno 4,5 a 1 sul fondo della fascia, altrimenti resta nell'inchiostro della pelle
      (anche dopo un cambio di colore del capo, che riveste la pagina).
   «Manda questa pagina» resta quello di bh-veste.js. */
(function () {
  'use strict';
  var d = document, h = d.documentElement;
  var rg = d.querySelector('#MainContent [data-bh-rg]');
  if (!rg) return;
  var bottone = rg.querySelector('.bh-rg__fascia');
  var pannello = rg.querySelector('.bh-rg__pannello');
  if (!bottone || !pannello) return;

  // ---------- 1. la fascia ----------
  bottone.addEventListener('click', function () {
    var aperto = bottone.getAttribute('aria-expanded') === 'true';
    bottone.setAttribute('aria-expanded', aperto ? 'false' : 'true');
    pannello.hidden = aperto;
  });

  // ---------- 2. il nastro ----------
  var T = { togli: '', rimetti: '' };
  var primo = rg.querySelector('.bh-rg__nastro small');
  if (primo) T.togli = primo.textContent;
  T.rimetti = rg.getAttribute('data-rimetti') || '';
  pannello.addEventListener('click', function (e) {
    var n = e.target && e.target.closest ? e.target.closest('.bh-rg__nastro') : null;
    if (!n) return;
    var q = d.getElementById(n.getAttribute('aria-controls'));
    var tolto = n.getAttribute('aria-expanded') !== 'true';
    n.setAttribute('aria-expanded', tolto ? 'true' : 'false');
    if (q) q.hidden = !tolto;
    var s = n.querySelector('small');
    if (s) s.textContent = tolto ? T.rimetti : T.togli;
  });

  // ---------- 3. le parole del Lato B ----------
  var righe = pannello.querySelectorAll('[data-bh-rg-parte]');
  if (righe.length) {
    var tpl = d.getElementById('bh-rg-latob');
    var src = tpl && tpl.content ? tpl.content : null;
    pannello.querySelectorAll('[data-bh-rg-slot]').forEach(function (slot) {
      var x = src ? src.querySelector('[data-bh-rg-da="' + slot.getAttribute('data-bh-rg-slot') + '"]') : null;
      slot.textContent = x ? x.textContent.trim() : '';
    });
    righe.forEach(function (li) {
      var testo = li.querySelector('[data-bh-rg-slot="' + li.getAttribute('data-bh-rg-parte') + '"]');
      if (!testo || !testo.textContent) li.parentNode.removeChild(li);
    });
  }

  // ---------- 4. il rosso delle buttate ----------
  var ROSSO = [179, 0, 27];  // #b3001b, lo stesso della regola .bh-rg--rosso nello snippet
  function rgb(s) {
    var m = String(s).match(/rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)/);
    return m ? [+m[1], +m[2], +m[3]] : null;
  }
  function lum(c) {
    var f = function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * f(c[0]) + 0.7152 * f(c[1]) + 0.0722 * f(c[2]);
  }
  function contrasto(a, b) {
    var x = lum(a), y = lum(b);
    return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
  }
  function rosso() {
    var fondo = rgb(getComputedStyle(bottone).backgroundColor);
    rg.classList.toggle('bh-rg--rosso', !!fondo && contrasto(fondo, ROSSO) >= 4.5);
  }
  rosso();
  if ('MutationObserver' in window) {
    // bh-veste.js riveste la pagina cambiando le variabili su <html> quando cambia il colore del capo
    new MutationObserver(function () { window.requestAnimationFrame(rosso); }).observe(h, { attributes: true, attributeFilter: ['style', 'class'] });
  }
})();
